import { Api } from '@/services/Api'

export default {
  reportDownload(param) {
    return Api().post(`api/v2/athena/fetch`, param)
  }
}